import { subAdminConstants } from "../constants/subAdminConstants";
import { subAdminService } from "../../services/API/subAdminService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const subAdminActions = {
  get_permission_list,
  savePermission
};

export const add_subadmin = postData => {
  return dispatch => {
    subAdminService.add_subadmin(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.ADD_SUBADMIN_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.ADD_SUBADMIN_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.ADD_SUBADMIN_FAILURE, error };
  }
};

function savePermission(postData) {
  return dispatch => {
    subAdminService.savePermission(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.SAVE_PERMISSION_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.SAVE_PERMISSION_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.SAVE_PERMISSION_FAILURE, error };
  }
}

export const get_permission_list = url => {
// function get_permission_list(userID) {
  return dispatch => {
    subAdminService.get_permission_list(url).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.GET_PERMISSIONLIST_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.GET_PERMISSIONLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.GET_PERMISSIONLIST_FAILURE, error };
  }
}

export const get_user_list = formData => {
  return dispatch => {
    subAdminService.get_user_list(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.GET_USERLIST_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.GET_USERLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.GET_USERLIST_FAILURE, error };
  }
};

export const allUser = formData => {
  return dispatch => {
    subAdminService.allUser(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.GET_USERLIST_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.GET_USERLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.GET_USERLIST_FAILURE, error };
  }
};


export const get_employee_list = formData => {
  return dispatch => {
    subAdminService.get_employee_list(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.GET_USERLIST_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.GET_USERLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.GET_USERLIST_FAILURE, error };
  }
};

export const delete_user = userIdAsParams => {
  return dispatch => {
    subAdminService.delete_user(userIdAsParams).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.DELETE_USER_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.DELETE_USER_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.DELETE_USER_FAILURE, error };
  }
};

export const update_user = postData => {
  return dispatch => {
    subAdminService.update_user(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.UPDATE_USER_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.UPDATE_USER_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.UPDATE_USER_FAILURE, error };
  }
};

export const get_user_details = (userIdParams, siteID) => {
  return dispatch => {
    subAdminService.get_user_details(userIdParams, siteID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.GET_USER_DETAILS_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.GET_USER_DETAILS_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.GET_USER_DETAILS_FAILURE, error };
  }
};

export const storeCredit = formData => {
  return dispatch => {
    subAdminService.storeCredit(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.POST_STORE_CREDIT_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.POST_STORE_CREDIT_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.POST_STORE_CREDIT_FAILURE, error };
  }
};

export const storePreview = (userID, siteID) => {
  return dispatch => {
    subAdminService.storePreview(userID, siteID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: subAdminConstants.GET_STORE_CREDIT_REQUEST, data };
  }
  function success(data) {
    return { type: subAdminConstants.GET_STORE_CREDIT_SUCCESS, data };
  }
  function failure(error) {
    return { type: subAdminConstants.GET_STORE_CREDIT_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/subAdminActions.js